import { useMeContext } from '../app/MeContext';
import { formatDayWithWeekday, formatTime, HOUR } from '../lib/time';
import { formatKop } from '../lib/money';
import { plural } from '../lib/plural';
import type { Appointment } from '../api/types';

/**
 * Отмена записи. Правило бесплатной отмены показываем до нажатия, но решает
 * сервер: он же возвращает `refunded` — по нему и говорим, что произошло.
 */
export function CancelSheet({ appointment, onConfirm, onClose }: {
  appointment: Appointment;
  onConfirm: () => void;
  onClose: () => void;
}) {
  const me = useMeContext();
  const tz = me.center.tz;
  const tf = me.center.timeFormat;
  const hours = me.center.cancelHours;
  const free = hours <= 0 || appointment.starts_at_utc - Date.now() >= hours * HOUR;

  return (
    <>
      <h3>Отменить запись?</h3>
      <p>
        {formatDayWithWeekday(appointment.starts_at_utc, tz)}, {formatTime(appointment.starts_at_utc, tz, tf)} —{' '}
        {appointment.service_title}, {appointment.specialist_name}.{' '}
        {hours <= 0
          ? `Отменить можно в любой момент до записи, ${formatKop(appointment.price_kop)} вернутся.`
          : free
            ? `До записи больше ${hours} ${plural(hours, 'часа', 'часов', 'часов')}, поэтому ${formatKop(appointment.price_kop)} вернутся.`
            : `До записи меньше ${hours} ${plural(hours, 'часа', 'часов', 'часов')} — по правилам организации оплата не возвращается.`}
      </p>
      <p>Слот освободится и снова станет доступен для записи.</p>
      <div className="row-actions">
        <button className="btn" onClick={onClose}>Оставить</button>
        <button className="btn solid-danger" onClick={onConfirm}>Отменить запись</button>
      </div>
    </>
  );
}
